
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneonlinecabbooking() {



  const cardData =
  {
    keyword: 'Pune Online Cab Booking Service',
    heading: 'AB Ghule Cabs: Pune Online Cab Booking Service',
    headingDescription: 'Booking a cab in Pune has never been easier with AB Ghule Cabs’ Pune Online Cab Booking Service. Whether you are planning a trip for business, leisure, or airport transfers, our hassle-free online booking system ensures you can book a ride at your convenience. We provide a fleet of well-maintained vehicles, professional drivers, and affordable pricing to guarantee a comfortable travel experience in Pune.',

    top: 'Top Places to Visit in Pune with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Shaniwar Wada",
          description: "Step into history at Shaniwar Wada, once the seat of the powerful Peshwas. This historic fort is famous for its stunning architecture and rich legacy, offering visitors a glimpse into Pune’s royal past."
        },
        {
          title: "Aga Khan Palace",
          description: "A national landmark that played a significant role during the freedom struggle, the Aga Khan Palace is known for its majestic beauty and peaceful gardens. It’s an ideal spot for history lovers and those interested in India’s independence movement."
        },
        {
          title: "Sinhagad Fort",
          description: "A favorite among trekkers, Sinhagad Fort is an ideal place to experience the region's rich history and breathtaking views. Its historical importance and scenic beauty make it a perfect spot for outdoor enthusiasts and nature lovers."
        },
        {
          title: "Pune Okayama Friendship Garden",
          description: "Inspired by Japanese garden designs, this serene location offers tranquility and lush green surroundings. Whether you’re looking to relax, enjoy a picnic, or take a peaceful stroll, the Pune Okayama Friendship Garden is an ideal escape."
        },
        {
          title: "Dagdusheth Halwai Ganapati Temple",
          description: "This iconic temple dedicated to Lord Ganesha is one of Pune’s most revered religious sites. The grandeur and vibrant atmosphere of the temple make it an important destination for devotees and tourists alike, especially during Ganesh Chaturthi."
        },
        {
          title: "Fergusson College",
          description: "Known for its historical significance and beautiful architecture, Fergusson College offers a pleasant walk around its grounds. The campus provides a picturesque environment, perfect for a relaxing stroll amidst greenery."
        },
        {
          title: "Pataleshwar Cave Temple",
          description: "A rock-cut cave temple dedicated to Lord Shiva, the Pataleshwar Cave Temple is a significant archaeological site. The ancient carvings and peaceful surroundings make it an enriching destination for history and architecture lovers."
        },
        {
          title: "Rajiv Gandhi Zoological Park",
          description: "Located in Katraj, this zoo is home to a variety of animals and offers an interactive experience for families and animal enthusiasts. It’s an educational spot, ideal for learning about wildlife conservation and enjoying nature."
        },
        {
          title: "Nehru Memorial Museum",
          description: "Dedicated to India’s first Prime Minister, Jawaharlal Nehru, this museum provides an insightful look into his life and contributions. It’s a great stop for those interested in Indian history and political heritage."
        },
        {
          title: "Mulshi Dam",
          description: "Just a short drive from Pune, Mulshi Dam is a beautiful spot surrounded by nature. Ideal for photography, picnics, and scenic walks, it’s the perfect place to unwind, especially during the monsoon season when the landscape is at its most picturesque."
        }
      ],


   services: [
    {
      "name": "Pune Instant Cab Booking",
      description: "Need a cab on the go? AB Ghule Cabs offers instant cab booking services in Pune. Whether you’re in a hurry or planning a last-minute trip, our quick booking system ensures you get a taxi without delay, anytime and anywhere in the city. With fast confirmation and no waiting time, we provide a seamless experience for immediate travel."
    },
    {
      "name": "Pune Online Car Hire",
      description: "Book a car effortlessly with AB Ghule Cabs’ online car hire services in Pune. We offer a variety of vehicles to choose from, including options for short rides, long trips, and everything in between. Our easy online booking system makes the process quick and hassle-free, giving you the freedom to travel at your convenience."
    },
    {
      "name": "Pune Mobile Cab Booking",
      description: "With AB Ghule Cabs, booking a cab via mobile is simple. Download our app or visit our website to book a ride instantly. Whether you’re commuting within Pune or heading to a nearby city, we provide reliable mobile cab services for all your travel needs, ensuring a convenient and efficient ride."
    },
    {
      "name": "Pune Online Taxi Reservations",
      description: "Make online taxi reservations in Pune with AB Ghule Cabs. Plan your trip in advance and enjoy a smooth ride with our professional drivers and well-maintained vehicles. Booking online ensures a stress-free experience every time, with no hassle and guaranteed punctuality for your ride."
    },
    {
      "name": "Pune Quick Cab Booking",
      description: "Need a cab quickly? AB Ghule Cabs offers quick cab booking in Pune. Our fast and reliable service ensures you’ll be on your way in no time, whether it’s for a local ride or an outstation trip. Book your ride effortlessly with us, and enjoy a comfortable and timely journey."
    },
    {
      "name": "Pune Online Ride Booking",
      description: "Book your ride online with AB Ghule Cabs for a seamless travel experience in Pune. Our user-friendly booking platform makes it easy to reserve a taxi for any occasion, whether it's for business, sightseeing, or events. We ensure a smooth and timely ride, every time you book with us."
    },
    {
      "name": "Pune Book Taxi Online",
      description: "Booking a taxi online in Pune is easy with AB Ghule Cabs. Use our online platform to book a taxi in just a few clicks. Whether you're looking for a ride for an airport transfer, business trip, or leisure outing, we have you covered with prompt and reliable service."
    },
    {
      "name": "Pune Online Taxi Service",
      description: "Experience the convenience of AB Ghule Cabs’ online taxi services in Pune. With just a few clicks, you can book a reliable taxi, choose your vehicle, and set your destination. Our services ensure a comfortable and punctual ride, offering an easy solution for all your travel needs."
    },
    {
      "name": "Pune Online Cab Booking",
      description: "AB Ghule Cabs makes online cab booking in Pune simple and efficient. Whether it’s for a local trip or an outstation journey, our booking system is easy to use and offers a variety of vehicle options to suit your needs. Reserve your ride quickly and enjoy a smooth travel experience."
    },
    {
      "name": "Book Cab From Mumbai to Pune",
      description: "Traveling from Mumbai to Pune? AB Ghule Cabs offers a seamless and convenient cab booking service for your journey. Book your ride online, and enjoy a comfortable, safe, and timely trip from Mumbai to Pune with our expert drivers. We ensure punctuality, safety, and comfort on every trip."
    },
    {
      "name": "AB Ghule Cabs",
      description: "AB Ghule Cabs offers reliable taxi services in Pune and surrounding areas. Whether you need a ride for a local journey or an outstation trip, we provide comfortable vehicles, professional drivers, and affordable rates for a hassle-free experience. Our online booking platform makes the process simple and convenient."
    },
    {
      "name": "Taxi Booking Pune",
      description: "Book your taxi in Pune with AB Ghule Cabs for fast, reliable, and affordable service. Whether it’s for a short trip or long-distance travel, our taxis are available around the clock to meet your needs. Booking is easy, and our drivers ensure a smooth and enjoyable ride."
    },
    {
      "name": "Online Taxi Booking Pune",
      description: "Enjoy the convenience of online taxi booking in Pune with AB Ghule Cabs. Our easy-to-use platform allows you to book a taxi from the comfort of your home or office, ensuring you get where you need to go without any hassle. Our professional drivers will ensure a smooth ride."
    },
    {
      "name": "Mumbai Airport to Pune Taxi Online Booking",
      description: "Traveling from Mumbai Airport to Pune? Book your taxi online with AB Ghule Cabs. We offer prompt and reliable services for airport transfers, ensuring you have a comfortable and timely ride to your destination. With our professional drivers, you’ll experience a stress-free and comfortable journey."
    },
    {
      "name": "Online Cab Booking Mumbai to Pune",
      description: "Book your Mumbai to Pune cab online with AB Ghule Cabs for a smooth and convenient ride. Our booking process is quick and easy, and we ensure timely arrivals and departures, so you can travel with peace of mind. Enjoy a comfortable journey with our professional drivers."
    },
    {
      "name": "Online Car Booking in Pune",
      description: "Book your car online with AB Ghule Cabs in Pune. Our fleet of vehicles is available for all types of journeys, from city trips to outstation travel. With just a few clicks, you can reserve a car and be on your way. Our booking system is efficient and ensures you can enjoy a comfortable journey without delays."
    },
    {
      "name": "Online Cabs in Pune",
      description: "Looking for online cabs in Pune? AB Ghule Cabs offers reliable online cab booking services. Whether it’s a short trip or a long journey, our cabs are available to meet your travel needs at competitive prices. Experience comfort, safety, and affordability with every ride."
    },
    {
      "name": "Online Cab Service in Pune",
      description: "AB Ghule Cabs provides efficient online cab services in Pune. Book a ride at any time, and enjoy a comfortable journey with our well-maintained vehicles and professional drivers. Whether you’re traveling locally or for an outstation trip, we provide quick and reliable taxi services."
    },
    {
      "name": "Online Taxi Pune",
      description: "Booking a taxi in Pune is easier than ever with AB Ghule Cabs. Simply book online, and enjoy a comfortable ride with one of our professional drivers. Whether it’s for a local trip or outstation travel, we have you covered with prompt and reliable taxi services."
    },
    {
      "name": "Taxi Booking in Pune",
      description: "Need a taxi in Pune? AB Ghule Cabs offers convenient taxi booking services, available online or by phone. We offer comfortable rides, professional drivers, and affordable rates for all your transportation needs. Whether for a business trip or leisure, we ensure a smooth and reliable ride."
    },
    {
      "name": "Pune to Shirdi Cab Booking Online",
      description: "Planning a trip from Pune to Shirdi? Book your cab online with AB Ghule Cabs for a comfortable, reliable, and affordable journey. Our online booking system makes it easy to secure a ride, and our experienced drivers ensure a smooth ride to this holy destination."
    },
    {
      "name": "Pune Online Cab Booking Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient taxi services, including Mumbai to Shirdi cab bookings. We ensure a smooth and enjoyable ride for all our customers, with convenient booking options and reliable service."
    }
],
tableData: [
    ["-Pune Instant Cab Booking", "-Pune Online Car Hire"],
    ["-Pune Mobile Cab Booking", "-Pune Online Taxi Reservations"],
    ["-Pune Quick Cab Booking", "-Pune Online Ride Booking"],
    ["-Pune Book Taxi Online", "-Pune Online Taxi Service"],
    ["-Pune Online Cab Booking", "-Book Cab From Mumbai to Pune"],
    ["-AB Ghule Cabs", "-Taxi Booking Pune"],
    ["-Online Taxi Booking Pune", "-Mumbai Airport to Pune Taxi Online Booking"],
    ["-Online Cab Booking Mumbai to Pune", "-Online Car Booking in Pune"],
    ["-Online Cabs in Pune", "-Online Cab Service in Pune"],
    ["-Online Taxi Pune", "-Taxi Booking in Pune"],
    ["-Pune to Shirdi Cab Booking Online", ""]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Seamless Online Booking Experience",
      WhyChoosedescription: "With AB Ghule Cabs, booking your taxi in Pune has never been easier. Our user-friendly website and mobile app allow you to book a cab with just a few clicks, whether you're on the go or planning ahead."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We offer round-the-clock online cab booking services, ensuring that you can book a ride at any time, day or night. Whether it’s a last-minute booking or scheduled ride, we are always ready to assist you."
    },
    {
      WhyChooseheading: "Wide Range of Vehicles",
      WhyChoosedescription: "Our fleet includes a variety of vehicles to meet your needs, from budget-friendly options to premium cars. Choose from sedans, SUVs, and more for your trip around Pune or beyond."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "Our pricing structure is competitive and transparent, with no hidden charges. You can easily view your fare estimate before confirming the booking, ensuring you get great value for your money."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "All our drivers are professionally trained, licensed, and background-checked. They are experienced in navigating Pune's roads, ensuring a safe and comfortable journey to your destination."
    },
    {
      WhyChooseheading: "Safe and Comfortable Rides",
      WhyChoosedescription: "Your safety and comfort are our top priorities. Our vehicles are well-maintained and regularly serviced to ensure a smooth ride. We also provide GPS tracking for added safety during your journey."
    },
    {
      WhyChooseheading: "Easy Payment Options",
      WhyChoosedescription: "We offer multiple payment methods, including cash, credit/debit cards, and online payments via our app or website. You can choose the payment option that suits you best for your convenience."
    },
    {
      WhyChooseheading: "Customer Support at Your Fingertips",
      WhyChoosedescription: "Our customer support team is just a call or message away. Whether you need assistance with booking, changing a ride, or have any questions during your journey, we're here to help you."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab online with AB Ghule Cabs in Pune?',
      answer: 'You can book a cab easily through our website or mobile app by entering your pick-up and drop-off locations, and confirming the booking. Alternatively, you can contact customer service if you need any assistance.',
    },
    {
      id: 'FAQ2',
      question: 'What types of vehicles are available for online booking in Pune?',
      answer: 'We offer a wide range of vehicles for online booking, including economy sedans, SUVs, and luxury cars. Choose the vehicle based on your preferences and the type of ride you need.',
    },
    {
      id: 'FAQ3',
      question: 'Is it safe to book a cab online with AB Ghule Cabs?',
      answer: 'Yes, booking a cab online with AB Ghule Cabs is completely safe. Our drivers are experienced and background-checked, and we ensure that our vehicles are well-maintained for your safety and comfort.',
    },
    {
      id: 'FAQ4',
      question: 'What payment methods do you accept for online cab bookings?',
      answer: 'We accept various payment methods including cash, credit/debit cards, and online payments through our app or website. This provides you with flexibility and convenience when paying for your ride.',
    },
    {
      id: 'FAQ5',
      question: 'How do I know the fare for my online cab booking?',
      answer: 'Before confirming your online booking, you can view the fare estimate based on your selected ride details. We provide clear and upfront pricing, with no hidden fees.',
    },
    {
      id: 'FAQ6',
      question: 'Can I modify or cancel my online booking?',
      answer: 'Yes, you can modify or cancel your booking through our website or app. If you need any help, our customer service team is available to assist you with changes to your booking.',
    },
    {
      id: 'FAQ7',
      question: 'How far in advance should I book a cab online?',
      answer: 'While you can book a cab online as early as you  like, we recommend booking in advance for peak hours or special events to ensure availability. Last-minute bookings are also accepted, depending on availability.',
    },
    {
      id: 'FAQ8',
      question: 'Is there any additional charge for waiting time or detours?',
      answer: 'Additional charges may apply for waiting time or detours, depending on the nature of the ride. These will be communicated to you in advance before you confirm your booking.',
    },
    {
      id: 'FAQ9',
      question: 'Do you offer intercity online cab bookings?',
      answer: 'Yes, we offer online cab bookings for intercity travel from Pune to nearby cities. Whether you are traveling for business or leisure, we provide comfortable and affordable intercity rides.',
    },
    {
      id: 'FAQ10',
      question: 'What sets AB Ghule Cabs apart from other online cab services in Pune?',
      answer: 'AB Ghule Cabs stands out for its seamless online booking system, competitive pricing, experienced drivers, and commitment to customer satisfaction. Our focus on safety, comfort, and convenience ensures that your ride experience is always pleasant.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Rajiv Nair",
      feedback: "I recently booked a cab online through the AB Ghule Cabs app for a business meeting in Pune. The booking process was smooth, and the car arrived on time. The driver was professional and knew the quickest routes, ensuring I was on time for my meeting. Highly recommend their services for anyone who needs reliable and efficient online cab booking in Pune.",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Aditi Deshmukh",
      feedback: "Booking a cab with AB Ghule Cabs was a breeze! I was traveling to Pune for a family trip and needed a ride from the airport. The app made the process super simple, and the ride was comfortable and safe. I’ll definitely use their services again.",
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune Online Cab Booking | Instant & Reliable Taxi Services</title>
  <meta name="description" content="Pune online cab booking services for quick and reliable rides. Book cabs instantly for local, airport, and outstation trips including Mumbai to Pune, Pune to Shirdi, and more." />
  <meta name="keywords" content="Pune Instant Cab Booking, Pune Online Car Hire, Pune Mobile Cab Booking, Pune Online Taxi Reservations, Pune Quick Cab Booking, Pune Online Ride Booking, Pune Book Taxi Online, Pune Online Taxi Service, Pune Online Cab Booking, Book Cab From Mumbai to Pune, AB Ghule Cabs, Taxi Booking Pune, Online Taxi Booking Pune, Mumbai Airport to Pune Taxi Online Booking, Online Cab Booking Mumbai to Pune, Online Car Booking in Pune, Online Cabs in Pune, Online Cab Service in Pune, Online Taxi Pune, Taxi Booking in Pune, Pune to Shirdi Cab Booking Online" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune Online Cab Booking | Instant & Reliable Taxi Services" />
  <meta property="og:description" content="Pune online cab booking services for quick and reliable rides. Book cabs instantly for local, airport, and outstation trips including Mumbai to Pune, Pune to Shirdi, and more." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-online-cab-booking.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-online-cab-booking" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />
  
  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune Online Cab Booking",
        description: "Pune online cab booking services for quick and reliable rides. Book cabs instantly for local, airport, and outstation trips including Mumbai to Pune, Pune to Shirdi, and more.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-online-cab-booking",
        "logo": "https://abghulecabs.com/images/pune-online-cab-booking.jpg",
        "image": "https://abghulecabs.com/images/pune-online-cab-booking.jpg",
        "priceRange": "₹1000 - ₹10000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-online-cab-booking",
          "priceCurrency": "INR",
          "price": "1000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "900"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rohit Verma"
            },
            "datePublished": "2024-12-20",
            "reviewBody": "The best online cab booking experience in Pune! The process was seamless, and the driver was punctual and professional."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya Kulkarni"
            },
            "datePublished": "2024-11-30",
            "reviewBody": "Booked a cab from Pune to Mumbai airport online. Quick and efficient service with competitive pricing."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-online-cab-booking"
        },
        "keywords": "Pune Instant Cab Booking, Pune Online Car Hire, Pune Mobile Cab Booking, Pune Online Taxi Reservations, Pune Quick Cab Booking, Pune Online Ride Booking, Pune Book Taxi Online, Pune Online Taxi Service, Pune Online Cab Booking, Book Cab From Mumbai to Pune, AB Ghule Cabs, Taxi Booking Pune, Online Taxi Booking Pune, Mumbai Airport to Pune Taxi Online Booking, Online Cab Booking Mumbai to Pune, Online Car Booking in Pune, Online Cabs in Pune, Online Cab Service in Pune, Online Taxi Pune, Taxi Booking in Pune, Pune to Shirdi Cab Booking Online"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/13.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Puneonlinecabbooking;